(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-footer.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-footer.js');

'use strict';

const constants = svs.maltipset.constants;
svs.maltipset.views.BetslipFooter = Marionette.View.extend({
  template(data) {
    return svs.maltipset.templates.betslip_footer(data);
  },
  className: 'betslip-footer-maltipset',
  modelEvents: {
    'change:totalCost': 'onChange',
    'change:system': 'onChange',
    'change:totalCompleteRows': 'onChange',
    'change:numWeeks': 'onChange'
  },
  initialize() {
    this.wasValid = this.model.get('isValid');
  },
  onChange() {
    this.render();
    const currentCoupon = svs.maltipset.collections.coupons.getCurrentCoupon();
    const isPayable = currentCoupon.isBoardValid();
    if (!this.wasValid && isPayable) {
      svs.maltipset.views.betslip.validBetslip({
        tracking: true,
        productName: constants.PRODUCT_NAME
      });
    }
    this.wasValid = this.model.get('isValid');
  },
  onRender() {
    if (!svs.core.detect.formfactor.mobile() && svs.maltipset.views.betslip) {
      svs.maltipset.views.coupon.getRegion('betslip').currentView.hideBetslipTag();
    } else {
      svs.maltipset.app.skeleton.getRegion('betslip').currentView.hideBetslipTag();
    }
  }
});

 })(window);